import React, { useContext } from 'react';
import DocumentOutlineItem from './DocumentOutlineItem';
import { DocumentOutlineContext } from './DocumentOutlineProvider';
import SidePanel from './SidePanel';

function renderNode(root) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, 'title' in root && /*#__PURE__*/React.createElement("a", {
    href: "#" + root.id
  }, root.title), /*#__PURE__*/React.createElement("ul", null, root.children.map(function (item, idx) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(DocumentOutlineItem, {
        key: idx
      }, renderNode(item))
    );
  })));
}

var shouldHideTree = function shouldHideTree(tree) {
  var _children$0$children;

  if (!tree) return true;
  var children = tree.children || [];
  if (!children.length) return false; // if there is only 1 child make sure it at least has one child

  if (children.length === 1 && !((_children$0$children = children[0].children) === null || _children$0$children === void 0 ? void 0 : _children$0$children.length)) return true;
  return false;
};

function DocumentOutline(props) {
  var ctx = useContext(DocumentOutlineContext); // TODO: warn instead

  if (!ctx || shouldHideTree(ctx.tree)) return null;
  return /*#__PURE__*/React.createElement(SidePanel, props, renderNode(ctx.tree));
}

export default DocumentOutline;